import dotPropImmutable from 'dot-prop-immutable';
import { TemplateObjectType } from 'data/templates/api';
export const variablesSlice = {
    setConditionalVariables: (state, { payload })=>{
        const { variableId, formValues, templateType } = payload;
        const path = `data.${state.activeId}.template.templateMeta.conditionalVariables`;
        const _payload = {
            formValues
        };
        if (templateType === TemplateObjectType.Project) {
            _payload.recordId = state.activeId;
        }
        return dotPropImmutable.merge(state, path, {
            [variableId]: _payload
        });
    },
    removeConditionalVariables: (state, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    { payload })=>{
        // const { variableId } = payload;
        // const path = `data.${state.activeId}.template.templateMeta.conditionalVariables.${variableId}`;
        /**
     * TODO: mark the variable as deleted
     * and unmark the same on undo
     * and on template save, delete the variables marked as deleted
     * before making API call.
     */ return state;
    // return {
    //   ...state,
    //   ...dotPropImmutable.delete(state, path),
    // };
    }
};
